import dayjs from "dayjs";
import { rdsMeeting_Dto } from "../../../interfaces/dtos/rdsMeeting";
import { rdsEvent_Dto } from "../../../interfaces/dtos/rdsEvent";
import { RdsState } from "../../../redux/rds/rdsSlice";
import { getDateKey } from "../../../redux/common/commonActions";
import { getSearchCategoryShared, updateSearchParamsForCategoryShared } from "../../shared/sharedHelper";

export const scheduleParamKeys = {
    date: 'date',
    category: 'category',
    sort: 'sort'
}

export const sortItems = [
    { key: 'OT', value: 'Off Time' }
]

export const getSearchDate = (searchParams: URLSearchParams) => {
    return searchParams.get(scheduleParamKeys.date) ? getDateFromParam(searchParams) : null;
}

export const getSearchCategory = (searchParams: URLSearchParams) => {
    return getSearchCategoryShared(searchParams, scheduleParamKeys.category);
}

const getDateFromParam = (searchParams: URLSearchParams) => {
    try {
        const dateFormatted = searchParams.get(scheduleParamKeys.date);
        if (dateFormatted?.length === 8) {
            const dateString = `${parseInt(dateFormatted.substring(0, 4))}-${parseInt(dateFormatted.substring(4, 6))}-${parseInt(dateFormatted.substring(6, 8))} 12:00`
            return new Date(dateString);
        } else {
            return new Date();
        }
    } catch {
        return new Date();
    }
}

export const updateSearchParamsForDate = (searchParams: URLSearchParams, searchDate: Date | string) => {
    const newSearchDateFormat = getDateFormatted(searchDate);
    searchParams.set(scheduleParamKeys.date, newSearchDateFormat);
    return searchParams;
}

export const updateSearchParamsForCategory = (searchParams: URLSearchParams, categoryCode: string) => {
    return updateSearchParamsForCategoryShared(searchParams, categoryCode, scheduleParamKeys.category);
}

export const getMeetingsToDisplay = (rds: RdsState, searchParams: URLSearchParams) => {
    return sortMeetings(rds.rdsMeetings.filter((m) => matchMeeting(m, searchParams)));
}

const matchMeeting = (meeting: rdsMeeting_Dto, searchParams: URLSearchParams) => {
    const date = getSearchDate(searchParams);
    const categoryCode = getSearchCategory(searchParams);
    if (date && categoryCode) {
        return meeting.dateKey === getDateKey(date) && meeting.categoryCode === categoryCode;
    } else {
        return false
    }
}

const sortMeetings = (meetings: rdsMeeting_Dto[]) => {
    if (!meetings || meetings.length === 0) {
        return meetings;
    }
    return [...meetings].toSorted((a, b) => (
        (a.description.toLowerCase() < b.description.toString().toLowerCase() ? -1 : 1)
    ));
}

export const sortScheduleEvents = (events: rdsEvent_Dto[]) => {
    return [...events].filter(e => e !== undefined).toSorted((a, b) => (
        (a.dateTime < b.dateTime ? -1 : 1)
    ));
}

export const getDateFormatted = (date: Date | string) => {
    return dayjs(date).format('YYYYMMDD');
}

export const getLoadingEvent = (meeting: rdsMeeting_Dto): rdsEvent_Dto => {
    return {
        id: -1,
        meetingId: meeting.id,
        name: 'loading',
        dateTime: new Date(),
        number: -1
    }
}